/**
 * Usage instructions:
 *
 * First, inititalise an intermediate component that uses a default
 * tag/component to satisfy the TS generic requirements (can be overriden
 * later):
 *
 *     const _MyComponent = forwardRef<HTMLDivElement, MyComponentProps>(
 *       ({ component = "div", ...rest }, ref) => {
 *         const Component = component;
 *
 *         return <Component ref={ref} {...rest} />;
 *       },
 *     );
 *
 * Then apply the `createPolymorphicComponent` util to allow the functionality
 * for polymorphism
 *
 *     export const MyComponent = createPolymorphicComponent<
 *       "div",
 *       MyComponentProps
 *     >(_MyComponent);
 *
 * You can override the default element type when using the component like so:
 *
 *     <MyComponent component="button" />;
 *
 * When using the ref property, in some cases the editor can't infer type
 * correctly. You can provide the generic type manually:
 *
 *     <MyComponent<"button"> component="button" />;
 *
 * More detailed usage documentation: https://mantine.dev/guides/polymorphic/
 */
export function createPolymorphicComponent(component) {
    return component;
}
